import React, { useCallback } from 'react';
import { useNavigate } from 'react-router';
import classNames from 'classnames';
import UIButton from 'Components/UIComponents/UIButton';
import UIModal from 'Components/UIComponents/UIModal';
import useIsMobile from 'Hooks/Common/useIsMobile';
import { AuthorizedRoutePaths, settingsRedirectionMap } from 'Interfaces/RoutePaths';
import { BillingPageActionType } from 'Pages/Settings/Billing/screens/BillingDefaultPlanScreen/planTableItems';

export interface TrialUpgradeModalProps {
  children: React.ReactChild | React.ReactChild[];
  title?: string;
  onUpgradeClick?: () => void;
  onCancel?: () => void;
}

const TrialUpgradeModal = ({
  children,
  title,
  onUpgradeClick,
  onCancel,
}: TrialUpgradeModalProps) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const handleUpgrade = useCallback(() => {
    if (onUpgradeClick) {
      onUpgradeClick();
    } else {
      navigate(settingsRedirectionMap[AuthorizedRoutePaths.SETTINGS_BILLING_PLAN], {
        state: { action: { type: BillingPageActionType.OPEN_COMPLETE_TRIAL_MODAL } },
      });
    }
  }, [navigate, onUpgradeClick]);

  return (
    <UIModal
      hideCloseIcon={true}
      onClose={() => {}}
      className={classNames('upgradeModal', { mobile: isMobile })}
    >
      <div className="upgradeModal__inner">
        <div className="upgradeModal__content">
          <h4 className="upgradeModal__title">
            {title || 'Please upgrade your Signaturely account!'}
          </h4>
          <p className="upgradeModal__text">{children}</p>
        </div>
        <UIButton
          priority="primary"
          title="Upgrade Account"
          handleClick={handleUpgrade}
        />
        <div className="upgradeModal__button--cancel" onClick={onCancel}>
          I&apos;ll pass for now
        </div>
      </div>
    </UIModal>
  );
};

export default TrialUpgradeModal;
